import { QueryClient } from '@tanstack/react-query';
import { ApiError } from '@/auth/api';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      // 4xx is stable across retries — RequireTile 403, expired-session 401, and
      // typo 404 will never flip to 200 on the next call. Retrying them doubles
      // WAF noise, extends user-perceived latency on hard failures, and can hit
      // per-user rate limits. Only retry transient 5xx / network errors once.
      retry: (failureCount, error) => {
        if (error instanceof ApiError && error.status >= 400 && error.status < 500) return false;
        return failureCount < 1;
      },
    },
    mutations: {
      // Mutations never auto-retry: side effects are not idempotent in general,
      // and 4xx/5xx alike should surface to the caller for explicit handling.
      retry: 0,
    },
  },
});
